export default {
  getParams(loadOptions) {
    const securityStore = useSecurityStore();
    let params = "?";
    if (loadOptions.istaxiDepotFilter && securityStore.selectedTaxiDepotsFilters.length) {
      loadOptions.filter ??= [];
      loadOptions.filter = loadOptions.filter.length ? [securityStore.selectedTaxiDepotsFilters, "and", [...loadOptions.filter]] : securityStore.selectedTaxiDepotsFilters;
    }
    ["filter", "select", "sort", "skip", "take", "group", "requireTotalCount", "summary", "totalSummary"].forEach(function (i) {
      if (i in loadOptions && loadOptions[i] !== undefined && loadOptions[i] !== null && loadOptions[i] !== "") {
        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
      }
    });
    params = params.slice(0, -1);
    return params;
  }
};